import { render, staticRenderFns } from "./SHCartCardSkeleton.vue?vue&type=template&id=3a5ef5b2"
import script from "./SHCartCardSkeleton.vue?vue&type=script&lang=ts"
export * from "./SHCartCardSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports